"use client";

import React from "react";
import Image from "next/image";

import { PortableText } from "@portabletext/react";
import { customRichTextComponent } from "@/sanity/sanityPortableText";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/shadcn/ui/accordion";

import { PageLaunchSchema } from "@/sanity/pages/PageLaunchTemplate";

import gridGBimg from "@/public/lp2/faq/grid-bg.svg";
import blurBGimg from "@/public/lp2/faq/blur-bg.svg";
import faqBG from "@/public/launch/faq-bg.jpg";

export default function FAQ({ data }: { data: PageLaunchSchema }) {
  return (
    <section className="w-full z-[1] relative pt-[6rem] lg:pt-0">
      {/* Backgrounds */}
      <Image
        className="absolute z-[-2] top-0 lg:top-[12rem] w-full lg:w-1/2 left-[50%] translate-x-[-50%] pointer-events-none"
        alt="Grid background"
        src={gridGBimg}
      />
      <Image
        className="faq-section-blur absolute z-[-3] top-[4rem] lg:top-[8rem] pointer-events-none lg:w-full left-[50%] translate-x-[-50%]"
        alt="Blur background"
        src={blurBGimg}
      />
      {/* End backgrounds */}
      <div className="max-w-[86rem] mx-auto relative z-[2] px-[2rem] lg:px-0">
        <div className="flex flex-col items-center justify-end w-full lg:h-[40rem] mb-[4rem] lg:mb-[4rem]">
          {data?.faqTexts && (
            <PortableText
              value={data?.faqTexts ?? []}
              components={customRichTextComponent({
                block: {
                  h2: ({ children }) => (
                    <h2 className="!text-white text-[5rem] lg:text-[7rem] font-[600] tracking-[-0.2rem] lg:tracking-[-0.28rem] leading-[100%] lg:leading-[120%] text-center my-[2rem]">
                      {children}
                    </h2>
                  ),
                },
              })}
            />
          )}
        </div>

        <Accordion type="single" collapsible className="w-full" defaultValue="item-0">
          {data?.faqItems?.map((faq, index) => (
            <AccordionItem
              key={index}
              value={`item-${index}`}
              className="bg-black/30 mb-[2rem] p-[.5rem] border border-white/10 rounded-[2rem]"
            >
              <div className="faq-items border border-white/10 rounded-[2rem] px-[4rem] py-[1.5rem] lg:py-[2.5rem] relative overflow-clip [&_h3]:mb-0">
                <Image
                  className="absolute z-[-1] top-0 h-full left-1/2 -translate-x-1/2 object-cover pointer-events-none"
                  alt="Background"
                  src={faqBG}
                />
                <AccordionTrigger className="text-white text-left text-[2.25rem] font-[400] leading-[3.375rem] opacity-85">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-white text-[2.25rem] font-[400] leading-[150%] opacity-60 pb-0">
                  {faq.answer}
                </AccordionContent>
              </div>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
